module.exports = __webpack_public_path__ + "static/media/css.98ae65a7.svg";